import Alpine from 'alpinejs'
import reducedMotion from 'helpers/reducedMotion'

export default (() => {
  if (window.pageSettings.editmode) return

  Alpine.data('panorama', function panorama({ duration = 8000 } = {}) {
    if (typeof duration === 'string') duration = parseInt(duration)

    let animation = null
    let timeout = null
    let observer = null
    let destroyed = false
    let updateAnimation

    return {
      async init() {
        const images = this.$refs['image']
        const getDiff = () => window.innerWidth - images.getBoundingClientRect().width
        const [imagesloaded, gsap] = await Promise.all([
          import('imagesloaded').then((m) => m.default),
          import('gsap').then((m) => m.default),
        ])
        if (destroyed) return

        updateAnimation = () => {
          clearTimeout(timeout)
          if (reducedMotion.matches) {
            animation?.revert()
            gsap.set(images, { clearProps: 'transform' })
            animation = null
            return
          }

          animation?.pause()
          timeout = setTimeout(() => {
            const seconds = Math.floor(Math.abs((getDiff() / 1000) * (duration / 1000)))
            if (animation) {
              animation.duration(seconds).invalidate().resume()
            } else {
              animation = gsap.fromTo(images, { x: 0 }, {
                x: getDiff,
                duration: seconds,
                ease: 'none',
                repeat: Infinity,
                yoyo: true,
              })
            }
          }, 800)
        }

        imagesloaded(images, () => {
          if (destroyed) return
          updateAnimation()
          reducedMotion.addEventListener('change', updateAnimation)
          if (typeof ResizeObserver !== 'undefined') {
            observer = new ResizeObserver(updateAnimation)
            observer.observe(images)
          } else {
            window.addEventListener('resize', updateAnimation)
          }
        })
      },
      destroy() {
        destroyed = true
        clearTimeout(timeout)
        observer?.disconnect()
        if (updateAnimation) {
          reducedMotion.removeEventListener('change', updateAnimation)
          window.removeEventListener('resize', updateAnimation)
        }
        animation?.revert()
      },
    }
  })
})()
